export const MODEL_IMAGE_API_BASE_URL = "https://webapp-im.luxottica.com/";
export const DEFAULT_IMAGE_WIDTH = 1200;
export const DEFAULT_THUMBNAIL_IMAGE_WIDTH = 400;
export const MODEL_3D_SPLM_21X_URL =
  "https://3dsplm25x.luxottica.com/3dspace/luxottica/LUXSearchModelByName.jsp?nomeModello=";
